import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11201cb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-layout" }

import { computed } from 'vue';
import CollageTileDefaultLayoutMediaWithLink
    from '@/shared/content/blocks/collage-layouts/default-layout-helpers/CollageTileDefaultLayoutMediaWithLink.vue';
import CollageTileDefaultLayoutTextAndLink
    from '@/shared/content/blocks/collage-layouts/default-layout-helpers/CollageTileDefaultLayoutTextAndLink.vue';
import { TileContentModel } from '@/types/B2BcontentServerContract';


export default /*#__PURE__*/_defineComponent({
  __name: 'CollageTileDefaultLayoutGridOptionB',
  props: {
    tileModelData: null,
    mirrorGrid: { type: Boolean },
    isFirstOrLast: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { tileModelData: TileContentModel, mirrorGrid: boolean, isFirstOrLast: boolean }



const aspectRatioFirstItem = computed(() => {
    return { default: 100 / 101 };
});

const aspectRatioSecondAndThirdItem = computed(() => {
    return {
        'max-sm': 1000 / 667,
        'max-md': props.isFirstOrLast ? 1000 / 501 : 1000 / 531,
        default: props.isFirstOrLast ? 1000 / 501 : 1000 / 529,
    };
});

const firstItem = computed(() => {
    return props.mirrorGrid ? props.tileModelData[2] : props.tileModelData[0];
});

const secondItem = computed(() => {
    return props.mirrorGrid ? props.tileModelData[0] : props.tileModelData[1];
});

const thirdItem = computed(() => {
    return props.mirrorGrid ? props.tileModelData[1] : props.tileModelData[2];
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(firstItem))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["item-1 relative", { 'item-1--mirrored': __props.mirrorGrid }])
        }, [
          _createVNode(CollageTileDefaultLayoutMediaWithLink, {
            data: _unref(firstItem),
            "aspect-ratio": _unref(aspectRatioFirstItem)
          }, null, 8, ["data", "aspect-ratio"]),
          _createVNode(CollageTileDefaultLayoutTextAndLink, { data: _unref(firstItem) }, null, 8, ["data"])
        ], 2))
      : _createCommentVNode("", true),
    (_unref(secondItem))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["item-2 relative", { 'item-2--mirrored': __props.mirrorGrid }])
        }, [
          _createVNode(CollageTileDefaultLayoutMediaWithLink, {
            data: _unref(secondItem),
            "aspect-ratio": _unref(aspectRatioSecondAndThirdItem)
          }, null, 8, ["data", "aspect-ratio"]),
          _createVNode(CollageTileDefaultLayoutTextAndLink, { data: _unref(secondItem) }, null, 8, ["data"])
        ], 2))
      : _createCommentVNode("", true),
    (_unref(thirdItem))
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["item-3 relative", { 'item-3--mirrored': __props.mirrorGrid }])
        }, [
          _createVNode(CollageTileDefaultLayoutMediaWithLink, {
            data: _unref(thirdItem),
            "aspect-ratio": _unref(aspectRatioSecondAndThirdItem)
          }, null, 8, ["data", "aspect-ratio"]),
          _createVNode(CollageTileDefaultLayoutTextAndLink, { data: _unref(thirdItem) }, null, 8, ["data"])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})